module.exports = __webpack_public_path__ + "static/media/aptistests_logo.6e08cc94.png";